(function () {
    'use strict';

    angular.module('sdhApp.childSelect', []).directive('childSelect', childSelect);
 
    childSelect.$inject = [];

    function childSelect() {

        var directive = {
            restrict: 'EA',
            scope: {
                model: "=model",
                temp: "=tempModel",
                show: "=show"
            },
            templateUrl: 'child-select.html',
            controller: ChildSelectController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;
    }

    ChildSelectController.$inject = ["$scope", "hotelService"];
    
    function ChildSelectController($scope, hotelService) {
        var vm = this;
        vm.error = false;

        // Change the count of input field to apply children ages
        vm.changeChildrenCount = function(num) {
            if((num < 0 && vm.temp.length > 0) || (num > 0 && vm.temp.length < hotelService.state.maxChildren)) {

                // Add or remove from array
                if(num > 0) {
                    vm.temp.push("");
                } else {
                    vm.temp.pop();
                }            
            }
        }

        vm.addChildren = function() {

            console.log(vm.temp);

            var valid = checkArray(vm.temp);

            if(valid) {
                vm.model = angular.copy(vm.temp);
                vm.error = false;
                vm.show = false;
            } else {
                vm.error = true;
            }
        }


        // Check for empty values
        function checkArray(my_arr){
            for(var i=0;i<my_arr.length;i++){
                if(my_arr[i] === "" || !my_arr[i])   
                    return false;
            }
            return true;
        }
    };



})();


